/**
 * Renders a read-only view of the attributes of an organization as well as an interface for adding users to and removing users from the organization.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Organization` model associated with the view.
 * @module app/views/admin/organizations/Details
 */
import Backbone from "backbone";
import _ from "underscore";
import Organization from "app/models/Organization";
import Field from "core/models/Field";
import User from "app/models/User";
import AddRemove from "app/views/admin/users/AddRemove";
import DetailView from "core/views/DetailView";
import UserCollection from "app/models/UserCollection";
import viewTemplate from "views/admin/organizations/Details";
import ErrorUtils from "app/utils/ErrorUtils";
import Helper from "app/ejs";
import messenger from "app/Messenger";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Organization} options.model The model to display.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
  },

  template: Helper.template(viewTemplate),
  className: "organization-details",

  render: function () {
    this.$el.html(
      this.template(
        _.defaults({}, this.options, {
          name: this.model.attributes.PrimaryName,
        })
      )
    );

    var detailView = new DetailView({
      model: this.options.model,
      fields: [
        new Field(Organization.fields["Address"]),
        new Field(Organization.fields["PhoneNumber"]),
        new Field(Organization.fields["EmailAddress"]),
      ],
    });

    detailView.render();
    detailView.$el.appendTo(this.$("#details .slider-outer .slider-content"));

    var userCollection = new UserCollection([]);

    userCollection.fetch({
      success: _.bind(function () {
        var collectionView = new AddRemove({
          fields: [
            new Field(User.fields["Username"]).decorate({
              id: "id",
              name: "id",
              viewOptions: {
                type: "link",
                linkField: "Username",
                linkUrl: "user",
              },
              sortable: "Username",
              filterable: "Username",
            }),
            new Field(User.fields["Name"]),
            new Field(User.fields["EmailAddress"]),
          ],
          users: userCollection,
          decider: _.bind(function (user) {
            return user.get("Organization") == this.model.id;
          }, this),
          inTabName: "Organization Users",
          outTabName: "Other Users",
        });

        collectionView.on(
          "add",
          function (user) {
            user.set("Organization", this.model.id);
            user.save(null, {
              success: function () {
                messenger.success("User added.");
              },
              error: ErrorUtils.apiHandler({
                activity: "adding the user",
              }),
            });
          },
          this
        );
        collectionView.on(
          "remove",
          function (user) {
            user.set("Organization", null);
            user.save(null, {
              success: function () {
                messenger.success("User removed.");
              },
              error: ErrorUtils.apiHandler({
                activity: "removing the user",
              }),
            });
          },
          this
        );
        collectionView.render();
        this.$("#users .slider-outer .slider-content").append(
          collectionView.$el
        );
      }, this),
      error: ErrorUtils.apiHandler({
        activity: "loading user information",
      }),
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/organizations/Details.js
// module id = 922
// module chunks = 1